/**
 * @generated SignedSource<<0c8afa66d4824710427702d491eab9e2>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type composerQueriesImagesGalleryImagesQueriesCategories_fragment$data = {
  readonly imageMacroCategories: ReadonlyArray<{
    readonly categories: ReadonlyArray<{
      readonly categoryPosition: number;
      readonly hasImages: boolean;
      readonly id: string;
      readonly isSystemwide: boolean;
      readonly name: string;
      readonly numberOfProducts: number;
    }>;
    readonly hasImages: boolean;
    readonly id: string;
    readonly isSystemwide: boolean;
    readonly macroCategoryPosition: number;
    readonly name: string;
    readonly numberOfProducts: number;
    readonly onlyForBackgrounds: boolean;
  }>;
  readonly " $fragmentType": "composerQueriesImagesGalleryImagesQueriesCategories_fragment";
};
export type composerQueriesImagesGalleryImagesQueriesCategories_fragment$key = {
  readonly " $data"?: composerQueriesImagesGalleryImagesQueriesCategories_fragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"composerQueriesImagesGalleryImagesQueriesCategories_fragment">;
};

import composerQueriesImagesGalleryImagesQueriesCategoriesFragmentQuery_graphql from './composerQueriesImagesGalleryImagesQueriesCategoriesFragmentQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasImages",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSystemwide",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numberOfProducts",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isLibrary"
    },
    {
      "kind": "RootArgument",
      "name": "onlybackground"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [],
      "operation": composerQueriesImagesGalleryImagesQueriesCategoriesFragmentQuery_graphql
    }
  },
  "name": "composerQueriesImagesGalleryImagesQueriesCategories_fragment",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "isLibrary",
          "variableName": "isLibrary"
        },
        {
          "kind": "Variable",
          "name": "onlybackground",
          "variableName": "onlybackground"
        }
      ],
      "concreteType": "ImageMacroCategory",
      "kind": "LinkedField",
      "name": "imageMacroCategories",
      "plural": true,
      "selections": [
        (v0/*:: as any*/),
        (v1/*:: as any*/),
        (v2/*:: as any*/),
        (v3/*:: as any*/),
        (v4/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "onlyForBackgrounds",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "macroCategoryPosition",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ImageCategory",
          "kind": "LinkedField",
          "name": "categories",
          "plural": true,
          "selections": [
            (v0/*:: as any*/),
            (v1/*:: as any*/),
            (v2/*:: as any*/),
            (v3/*:: as any*/),
            (v4/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "categoryPosition",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "6b77591cb59dc6676fab55d1b5ba83bd";

export default node;
